import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../physicalActivityAction';
import fetchApi from "./fetchApi";

function fetchPhysicalActivityAction() {
  return fetchApi('/v1/fc_api/physical_activity_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchPhysicalActivityAction;
